import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmMakeForm from '../../../components/forms/FirearmMakeForm';
import { useFirearmMakeById, useUpdateFirearmMake } from '../../../hooks/useFirearmMakeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmMakeDTO } from '../../../services/apiClient';

const FirearmMakeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmMakeById(id!);
  const updateFirearmMake = useUpdateFirearmMake();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Makes', href: '/admin/firearmmakes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmMake.mutateAsync({ id: id!, data });
      navigate('/admin/firearmmakes');
    } catch (error) {
      console.error('Error updating FirearmMake:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmmakes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmMake.Edit'
    >
        {entityData ? (
          <FirearmMakeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmmakes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmMakeEdit;